import React from "react";
import { useOverrides, Override } from "@quarkly/components";
import { Link, Box, Section } from "@quarkly/widgets";
import QuarklycommunityKitMobileSidePanel from "./QuarklycommunityKitMobileSidePanel";
const defaultProps = {
	"padding": "47px 0 47px 0"
};
const overrides = {
	"box": {
		"kind": "Box",
		"props": {
			"width": "40%",
			"sm-width": "50%",
			"empty-min-width": "64px",
			"empty-min-height": "64px",
			"empty-border-width": "1px",
			"empty-border-style": "solid",
			"empty-border-color": "LightGray"
		}
	},
	"link": {
		"kind": "Link",
		"props": {
			"href": "/",
			"font": "400 28px/1.5 --fontFamily-googleMarcellus",
			"color": "--secondary",
			"text-decoration-line": "initial",
			"md-font": "400 24px/1.5 --fontFamily-googleMarcellus",
			"children": "Frintala Workhouse"
		}
	},
	"box1": {
		"kind": "Box",
		"props": {
			"empty-border-width": "1px",
			"width": "60%",
			"justify-content": "flex-end",
			"empty-min-height": "64px",
			"empty-border-style": "solid",
			"empty-border-color": "LightGray",
			"display": "flex",
			"align-items": "center",
			"empty-min-width": "64px"
		}
	},
	"quarklycommunityKitMobileSidePanel": {
		"kind": "QuarklycommunityKitMobileSidePanel",
		"props": {}
	},
	"quarklycommunityKitMobileSidePanelOverride": {
		"kind": "Override",
		"props": {
			"slot": "Button Text",
			"md-color": "--coralD1",
			"md-font": "--lead"
		}
	},
	"quarklycommunityKitMobileSidePanelOverride1": {
		"kind": "Override",
		"props": {
			"slot": "Button Text :closed",
			"children": "Menu"
		}
	},
	"quarklycommunityKitMobileSidePanelOverride2": {
		"kind": "Override",
		"props": {
			"slot": "Button Icon",
			"md-color": "--coralD1"
		}
	},
	"quarklycommunityKitMobileSidePanelOverride3": {
		"kind": "Override",
		"props": {
			"slot": "Content",
			"background": "none",
			"padding": "0px 0px 0px 0px"
		}
	},
	"quarklycommunityKitMobileSidePanelOverride4": {
		"kind": "Override",
		"props": {
			"slot": "Button Text :open",
			"children": "Menu"
		}
	},
	"box2": {
		"kind": "Box",
		"props": {
			"justify-content": "space-between",
			"md-flex-direction": "column",
			"md-align-items": "center",
			"md-background": "--color-pageBg",
			"md-padding": "20px 0px 20px 0px",
			"display": "flex"
		}
	},
	"link1": {
		"kind": "Link",
		"props": {
			"transition": "opacity 0.3s ease-in-out 0s",
			"hover-opacity": ".8",
			"href": "/index",
			"color": "--darkL2",
			"font": "--lead",
			"text-decoration-line": "initial",
			"padding": "8px 8px 8px 8px",
			"children": "Homepage"
		}
	},
	"link2": {
		"kind": "Link",
		"props": {
			"color": "--darkL2",
			"font": "--lead",
			"text-decoration-line": "initial",
			"padding": "8px 8px 8px 8px",
			"transition": "opacity 0.3s ease-in-out 0s",
			"hover-opacity": ".8",
			"href": "/how-to",
			"children": "Contacts"
		}
	},
	"link3": {
		"kind": "Link",
		"props": {
			"color": "--darkL2",
			"font": "--lead",
			"text-decoration-line": "initial",
			"padding": "8px 8px 8px 8px",
			"transition": "opacity 0.3s ease-in-out 0s",
			"hover-opacity": ".8",
			"href": "/faq",
			"children": "FAQ"
		}
	},
	"link4": {
		"kind": "Link",
		"props": {
			"href": "/privacy-policy",
			"color": "--darkL2",
			"font": "--lead",
			"text-decoration-line": "initial",
			"padding": "8px 8px 8px 8px",
			"transition": "opacity 0.3s ease-in-out 0s",
			"hover-opacity": ".8",
			"children": "Privacy Policy"
		}
	},
	"link5": {
		"kind": "Link",
		"props": {
			"href": "/terms-and-conditions",
			"color": "--darkL2",
			"font": "--lead",
			"text-decoration-line": "initial",
			"padding": "8px 8px 8px 8px",
			"transition": "opacity 0.3s ease-in-out 0s",
			"hover-opacity": ".8",
			"children": "Terms and Conditions"
		}
	}
};

const Header2 = props => {
	const {
		override,
		children,
		rest
	} = useOverrides(props, overrides, defaultProps);
	return <Section {...rest}>
		<Override slot="SectionContent" flex-direction="row" />
		<Box {...override("box")}>
			<Link {...override("link")} />
		</Box>
		<Box {...override("box1")}>
			<QuarklycommunityKitMobileSidePanel {...override("quarklycommunityKitMobileSidePanel")}>
				<Override {...override("quarklycommunityKitMobileSidePanelOverride")} />
				<Override {...override("quarklycommunityKitMobileSidePanelOverride1")} />
				<Override {...override("quarklycommunityKitMobileSidePanelOverride2")} />
				<Override {...override("quarklycommunityKitMobileSidePanelOverride3")} />
				<Override {...override("quarklycommunityKitMobileSidePanelOverride4")} />
				<Box {...override("box2")}>
					<Link {...override("link1")} />
					<Link {...override("link2")} />
					<Link {...override("link3")} />
					<Link {...override("link4")} />
					<Link {...override("link5")} />
				</Box>
			</QuarklycommunityKitMobileSidePanel>
		</Box>
		{children}
	</Section>;
};

Object.assign(Header2, { ...Section,
	defaultProps,
	overrides
});
export default Header2;